'use client';

import { Box, HStack, Text } from '@chakra-ui/react';

import SearchInput from '@/components/business/SearchInput/SearchInput';
import FilterSelect from '@/components/ui/FilterSelect/FilterSelect';
import FilterTags from '@/components/ui/FilterTags/FilterTags';

import ExecutionLogsPage from '../ExecutionLogsPage/ExecutionLogsPage';

import AgentDetailsSidebar from './components/AgentDetailsSidebar/AgentDetailsSidebar';
import AgentsMainContent from './components/AgentsMainContent/AgentsMainContent';
import AssignCustomersModal from './components/AssignCustomersModal/AssignCustomersModal';
import useAgentsPage from './useAgentsPage';

const AgentsPage = () => {
  const {
    agentsData,
    selectedAgent,
    isSidebarOpen,
    isAssignModalOpen,
    page,
    setPage,
    handleSearch,
    customerOptions,
    selectedCustomers,
    handleCustomerChange,
    searchCustomers,
    handleSearchCustomers,
    handleRemoveFilter,
    handleClearAllFilters,
    isLoadingAgents,
    createFilterTags,
    handleAgentEdit,
    handleCloseSidebar,
    handleRemoveCustomer,
    handleAssignMoreCustomers,
    handleCloseAssignModal,
    handleSaveAssignments,
    allCustomers,
    isLoadingAllCustomers,
    handleSave,
    handleRunAgent,
    assignedCustomers,
    isLoadingAssignAgentToCustomers,
    isExecuting,
    setIsExecuting,
    agentRunData,
  } = useAgentsPage();

  if (isExecuting) {
    return <ExecutionLogsPage
      isExecuting={isExecuting}
      agentId={agentRunData?.agent.referenceId}
      agentConfigId={agentRunData?.configId}
      agentSchema={agentRunData?.agent.schema.output}
      properties={agentRunData?.properties}
      agentService={agentRunData?.agent.service}
      setIsExecuting={setIsExecuting} />;
  }

  return (
    <>
      <Box px={6} py={8} backgroundColor="white" borderRadius={12}>
        <Text fontSize={24} fontWeight={500} color="fg">
          Agents
        </Text>
        <Box mb={5} display="flex" flexDirection="column" gap={6}>
          <HStack gap={6} align="flex-end">
            <Box maxWidth="410px" width="100%">
              <SearchInput onChange={handleSearch} />
            </Box>
            <FilterSelect
              label="Customer"
              options={customerOptions}
              selectedValues={selectedCustomers}
              onChange={handleCustomerChange}
              placeholder="Select customer"
              showSearch
              searchPlaceholder="Search customers"
              searchValue={searchCustomers}
              onSearchChange={handleSearchCustomers}
              maxWidth="265px"
              width="100%"
              debouncedSearch
            />
          </HStack>
          <FilterTags
            filters={[...createFilterTags(selectedCustomers, 'customer')]}
            onRemoveFilter={handleRemoveFilter}
            onClearAll={handleClearAllFilters}
          />
        </Box>
        <AgentsMainContent
          agentsData={agentsData}
          page={page}
          setPage={setPage}
          isLoading={isLoadingAgents}
          onAgentClick={handleAgentEdit}
        />
      </Box>
      <AgentDetailsSidebar
        isOpen={isSidebarOpen}
        onClose={handleCloseSidebar}
        agent={selectedAgent}
        onRemoveCustomer={handleRemoveCustomer}
        onAssignMoreCustomers={handleAssignMoreCustomers}
        assignedCustomers={assignedCustomers}
        onSave={handleSave}
        onRunAgent={handleRunAgent}
        isLoadingAssignAgentToCustomers={isLoadingAssignAgentToCustomers}
      />
      <AssignCustomersModal
        isOpen={isAssignModalOpen}
        onClose={handleCloseAssignModal}
        customers={allCustomers}
        assignedCustomers={assignedCustomers}
        onSave={handleSaveAssignments}
        isLoading={isLoadingAllCustomers}
      />
    </>
  );
};

export default AgentsPage;
